import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Diamond = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M28 11C28 10.8 27.937 10.6 27.837 10.45L23.837 4.45C23.649 4.175 23.337 4 23 4H9.00002C8.66202 4 8.35002 4.162 8.16202 4.45L4.16202 10.45C4.06202 10.6 3.99902 10.8 3.99902 11C3.99902 11.213 4.06202 11.4 4.17402 11.563L15.174 27.563C15.362 27.838 15.674 28.001 15.999 28.001C16.324 28.001 16.636 27.838 16.824 27.563L27.824 11.563C27.937 11.401 27.999 11.213 27.999 11H28ZM9.53702 6H13.612L12.274 10H6.86202L9.53702 6ZM6.90002 12H12.175L14.15 22.538L6.90002 12.001V12ZM16.538 24.45L14.2 12H25.1L16.537 24.45H16.538ZM14.387 10L15.725 6H22.475L25.138 10H14.388H14.387Z" />
	</svg>
);

export default Diamond;
